export default __webpack_public_path__ + "static/media/gallery-wip-neck-ring_04.023dc0b6.jpg";